import { FC, useEffect, useMemo, useState } from 'react';

import { useTheme } from 'styled-components';

import { useMediaQuery } from '~/common/hooks/use-media-query';
import { Typography } from '~/common/components/Typograph';
import { Modal } from '~/common/components/Modal';
import { Button } from '~/common/components/Button';

import { ModalContent } from './styles';

interface ISubscriptionChangeModalProps {
  openFor:
    | 'new-subscription'
    | 'canceled-subscription-change'
    | 'canceled-subscription'
    | null;
  close: () => void;
}
export const SubscriptionChangeModal: FC<ISubscriptionChangeModalProps> = ({
  openFor,
  close,
}) => {
  const isMobile = useMediaQuery('(max-width: 750px)');
  const theme = useTheme();
  const [currentModalType, setCurrentModalType] = useState(openFor);

  useEffect(() => {
    if (openFor) {
      setCurrentModalType(openFor);
    }
  }, [openFor]);

  const title = useMemo(() => {
    if (currentModalType === 'new-subscription') {
      return 'Parabéns!';
    }

    if (currentModalType === 'canceled-subscription-change') {
      return 'Plano mantido!';
    }

    return 'Sentiremos sua falta!';
  }, [currentModalType]);

  const text = useMemo(() => {
    if (currentModalType === 'new-subscription') {
      return 'Sua assinatura foi atualizada com sucesso! Aproveite todos os recursos disponíveis para o seu novo plano.';
    }

    if (currentModalType === 'canceled-subscription-change') {
      return 'Notamos que mudou de ideia sobre a alteração do seu plano. Seu plano anterior foi mantido.';
    }

    return 'Lamentamos ver você cancelar sua assinatura. Esperamos vê-lo novamente em breve!';
  }, [currentModalType]);

  return (
    <Modal
      isOpen={!!openFor}
      onClose={close}
      id="forbidden-prompt-modal"
      height={isMobile ? '240px' : 'auto'}
      width="400px"
      title={title}
    >
      <ModalContent>
        <Typography.Label
          size="medium"
          color="neutral0"
          {...(isMobile && {
            style: {
              marginBottom: 'auto',
            },
          })}
        >
          {text}
        </Typography.Label>

        <Button
          text="Fechar"
          width="100%"
          backgroundColor={theme.primary}
          onClick={close}
        />
      </ModalContent>
    </Modal>
  );
};
